import $ from 'jquery'

export default {
    name: 'manage-bilan-sante',
    components: {},
    props: {
        modal_title: String,
        bilan_to_edit: Object,
        modal_toggler: Boolean
    },
    data() {
        return {
            bilan: {
                id: 0,
                libelle: '',
                examens: [],
                analyses: []
            },

            search_word: '',
            search_word_examen: '',
            loading: false,

            all_is_empty: false,
            is_exist: false,

            can_show_examen: false,
            can_show_analyse: false
        }
    },

    watch: {
        search_word() {
            this.searchAnalyse()
        },

        search_word_examen(){
            this.searchExamen()
        },

        bilan_to_edit() {
            this.setComposition()
        },

        modal_toggler() {
            this.bilan = {
                id: 0,
                libelle: '',
                examens: [],
                analyses: []
            }
        },
    },

    computed: {
        categoriesAnalyses() {
            return this.$store.getters["categoriesAnalyses"];
        },
        
        examens(){
          return this.$store.getters["examens"];
        },
    },

    mounted() {
        this.$store.dispatch("getCategoriesAnalyses");
        this.$store.dispatch("getExamens");

        $('#modal_bilan .modal-body').on("scroll", function(){
      
            let div_top = $('.searchbox').offset().top;
      
            if(div_top<0){
              $("#modal_bilan .show-on-fixed-create").fadeIn()
              $("#modal_bilan .modal-body").addClass("pt-0")
      
            } else{
              $("#modal_bilan .show-on-fixed-create").fadeOut()
              $("#modal_bilan .modal-body").removeClass("pt-0")
            } 
        })
    },

    methods: {
        searchAnalyse: function(){
            this.$store.dispatch('searchAnalyses',this.search_word)
        },

        searchExamen: function(){
            this.$store.dispatch('searchExamen',this.search_word_examen)
        },

        setComposition() {
            this.bilan = {
                id: 0,
                libelle: '',
                examens: [],
                analyses: []
            }

            // Analyses
            if (this.bilan_to_edit.analyses) {
                this.can_show_analyse = true
                this.bilan_to_edit.analyses.forEach((el) => {
                    this.bilan.analyses.push(el.analyse_id)
                });
            } else {
                this.can_show_analyse = false
            }

            

            // Examens
            if (this.bilan_to_edit.examens) {
                this.can_show_examen = true
                this.bilan_to_edit.examens.forEach((el) => {
                    this.bilan.examens.push(el.examen_id)
                });
            } else {
                this.can_show_examen = false
            }

            
            

            this.bilan.id = this.bilan_to_edit.id
            this.bilan.libelle = this.bilan_to_edit.libelle
        },

        async submit() {
            const isValid = await this.$refs.bilan_form.validate();

            if (!isValid) {
                return;
            }

            // Chek if one "Analyse" or "Examen" is selected
            let len_analyse = this.bilan.analyses.length 
            let len_examen = this.bilan.examens.length 

            if (len_analyse == 0 && len_examen == 0) {
                this.all_is_empty = true
                return;
            }

            this.loading = true

            this.$store.dispatch('saveBilanSante', this.bilan).then((response) => {
                if (response > 0) {
                    this.successToast("Bilan de santé ajouté avec succès")

                    this.$refs.bilan_form.reset()
                    this.$refs.modal_bilan.click()
                    this.bilan = {
                        id: 0,
                        libelle: '',
                        examens: [],
                        analyses: []
                    }

                    this.$emit('emitBilanSante')
                } else {
                    this.is_exist = true
                }

                this.loading = false
            }).catch(() => {
                this.loading = false
            })
            
        },

        scrolly: function(){
            var div_top = $('.stickanal').offset().top
            console.log(div_top)
        },

        sc: function(){
            // --
        },

        clearError() {
            this.all_is_empty = false
            this.is_exist = false
        }
    }
}